import { render, staticRenderFns } from "./EconomyPayments.vue?vue&type=template&id=76722874&scoped=true"
import script from "./EconomyPayments.vue?vue&type=script&lang=js"
export * from "./EconomyPayments.vue?vue&type=script&lang=js"
import style0 from "./EconomyPayments.vue?vue&type=style&index=0&id=76722874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76722874",
  null
  
)

export default component.exports